<template>
  <div class="thumb portrait-animation-box">
    <a
      href="javascript:void(0)"
      role="button"
      @click.prevent="$emit('on-click')"
    >
      <div class="animation-box-wrapper">
        <img
          v-if="motionThumbnail"
          :src="motionThumbnail"
          class="thumb-img"
          :alt="imageAlt"
          :style="{
            display: isImageLoaded ? 'block' : 'none',
          }"
          @load="changeImageLoadedState(true)"
          @error="changeImageLoadedState(false)"
        />
        <WebpImage
          v-else
          :image-info="{
            imageUrl: staticThumbnailInfo.url,
            width: thumbnailInfo.width,
            height: thumbnailInfo.height,
            alt: imageAlt,
            quality: 100,
            className: 'thumb-img',
            envPrefix: staticThumbnailInfo.envPrefix,
            onImageLoad: () => changeImageLoadedState(true),
            onImageError: () => changeImageLoadedState(false),
          }"
        />
        <div
          v-if="!isImageLoaded"
          :class="['animation-alt-wrapper', { 'no-thumb': !isImageLoaded }]"
        >
          <span>{{ imageAlt }}</span>
        </div>
      </div>
    </a>
  </div>
</template>
<script setup>
  import { computed, ref } from 'vue'
  import {
    addPrefixThumbnail,
    removeOrigin,
    addImageDomain,
  } from '@/common/utils/image'
  import { getEnvPrefix } from '@/common/utils/url.utils'
  import { getDomainWithPrefix } from '@/common/utils/common'
  import WebpImage from '@/components/image/WebpImage'

  const props = defineProps({
    cellInfo: {
      default: () => ({}),
      type: Object,
    },
    cellType: {
      type: String,
    },
    thumbnailInfo: {
      default: () => ({}),
      type: Object,
    },
  })

  const isImageLoaded = ref(false)

  const getThumbnailUrl = (url) => {
    if (!url && url === '') return
    const envPrefix = getEnvPrefix(url)
    const thumbnailUrl = removeOrigin(url)
    const thumbnailImagePath =
      thumbnailUrl[0] === '/' ? thumbnailUrl.substring(1) : thumbnailUrl

    return getDomainWithPrefix(
      addPrefixThumbnail(
        addImageDomain(`v1/thumbnails/0_0/${thumbnailImagePath}`),
      ),
      envPrefix,
    )
  }

  const motionThumbnail = computed(() => {
    const originImageUrl = props.cellInfo?.motion_thumbnail
    if (!originImageUrl || originImageUrl === '') return
    return getThumbnailUrl(originImageUrl)
  })

  const staticThumbnailInfo = computed(() => {
    const envPrefix = props.cellInfo?.thumbnail.match(
      /^(https?:\/\/)(dev|qa)/,
    )?.[2]

    return {
      url: props.cellInfo?.thumbnail,
      envPrefix,
    }
  })

  const imageAlt = computed(
    () => props.cellInfo?.alt || props.cellInfo?.logo_title || '이미지',
  )

  const changeImageLoadedState = (value) => {
    isImageLoaded.value = value
  }
</script>

<style lang="scss">
  .portrait-animation-box {
    width: 200px;
    height: 100px;
    .animation-box-wrapper {
      width: 200px;
      height: 100px;
      position: relative;
      overflow: hidden;
      border-radius: 12px;
      background: #2f2f2f;
      border: 0.7px solid rgba(255, 255, 255, 0.1);
      box-sizing: border-box;
      img,
      .thumb-img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        object-fit: cover;
      }
      .animation-alt-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: 0 16px;
        span {
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2; /* 라인수 */
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          font-size: 22px;
          color: #fff;
          text-align: center;
          line-height: 32px;
          font-weight: 700;
          white-space: inherit;
        }
      }
    }
  }
</style>
